import BadgesValueV2 from "../BadgesValueV2";
import GamesBadgeRequirements from "./GamesBadgeRequirements";

export default class GamesBadgesValue extends BadgesValueV2 {
  public requirements: GamesBadgeRequirements = new GamesBadgeRequirements();
}
